export default __webpack_public_path__ + "static/ville-de-quebec-49fc936acabe3aa45fb6d5b49854f622.png";